import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { Link } from "react-router-dom"
import { withRouter } from "react-router-dom"
import ReactTooltip from "react-tooltip"
import Icon from "../../icon/icon.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { messages, getMessage, handleClick } from "./helpers.jsx"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    isProtected: boolean
    protectionRule: boolean
    disabled: boolean
    protectedClassName: string
    accountFeatureKey: string
    className: string
    type: "button" | "submit" | "reset"
    children: JSX.Element
    showLock: boolean
    premium: boolean
    message: string
    to: string
    callback: () => void
    onClose: () => void
    onClickProtected: () => void
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    intl: Intl
}

const LinkWrapper = (props: OwnProps) => {
    const [displayModal, setDisplayModal] = useState(false)
    const showLock = props.showLock ?? true

    const lockedItem = <span key={"tooltip-container-link-wrapper"} data-tip data-for={"linkLock-link-wrapper"}>
        <Link key={"link-wrapper"}
            className={props.protectedClassName || "btn"}
            to="/" onClick={(e) => handleClick(e, props, setDisplayModal)}
            disabled={props.disabled} type={props.type}>
            <ReactTooltip place="bottom" className="linkLock" id={"linkLock-link-wrapper"} type="warning" effect="solid"
                multiline={true}>
                {getMessage(props.message, props.intl.formatMessage(messages["update_subscription"]))}
            </ReactTooltip>
            {props.children} {showLock && <Icon value="lock" className="lock"/>}
        </Link>
    </span>

    const item = <Link key={"link-wrapper"} className={props.className} to={props.to}>
        {props.children}
    </Link>

    return (<>
        <FeatureProtectionWrapperMain
            protectionRule={props.protectionRule}
            accountFeatureKey={props.accountFeatureKey}
            isProtected={props.isProtected ?? true}
            displayModal={displayModal}
            premium={props.premium}
            lockedItem={lockedItem}
            message={props.message}
            item={item}
            callback={props.callback || function () {
                return
            }}
            onClickProtected={props.onClickProtected || function () {
                return
            }}
            onClose={() => {
                setDisplayModal(false)
                if (props.onClose) {
                    props.onClose()
                }
            }}
            onClick={props.onClick || function () {
                return
            }}
        >

        </FeatureProtectionWrapperMain>
    </>)


}

export default withRouter(injectIntl(LinkWrapper))


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/linkWrapper.component.tsx